/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/thoughtful/twenty-two.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/thoughtful/twenty-two.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/twenty-two.mdx';

const metadata = {
  slug: "twenty-two",
  title: "Twenty Two",
  author: "Christian Battaglia",
  description: "My golden birthday — 22 on December 22nd. A look back at Maryland, Georgia, Georgia Tech, and what's ahead as I pack up for 8 months in Barcelona with no idea what I'm doing. Time to put on the big boy pants.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris-profile-hat.jpg",
  headerImage: "/assets-cdbattaglia/media/blog-posts/2015-12-22_up-and-chugging/bday-header.webp",
  date: "2015-12-22T00:00:00.000Z",
  
  readTime: "5 min read",
  tags: ["personal","birthday","Barcelona","Georgia Tech","growth","beginnings","Adobe","life lessons"],
};

export const Route = createFileRoute('/blog/posts/twenty-two')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/twenty-two',
    image: '/og/blog/twenty-two.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
